import { apiClient } from '@repo/shared';

const initialiseNewParent = () => {
  return {
    id: null,
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: ""
  };
}

const get = async (id) => {
  const parent = await apiClient.get(`/api/parents/${id}`);
  return parent;
};

const getParents = async () => {
  const parents = await apiClient.get("/api/parents");
  return parents;
};

const deleteSubmission = async (emailAddress, verificationCode) => {
  const response = await apiClient.delete(`/api/parents/registration/${emailAddress}?verificationCode=${verificationCode}`);
  return response;
};

const deleteParent = async id => {
  const response = await apiClient.delete(`/api/parents/${id}`);
  return response;
};

const update = async (id, parent) => {
  return await apiClient.post(`/api/parents/${id}`, parent);
};

const create = async (parent) => {
  return await apiClient.post(`/api/parents`, parent);
};


const ParentService = {
  update,
  initialiseNewParent,
  get,
  getParents,
  deleteSubmission,
  deleteParent,
  create
};

export default ParentService;